<template>
  <div class="emh-side-filters-equipment-category">
    <emh-side-filters-category-filter-template
      v-for="filter in filters"
      :key="filter.name"
      :title="filterCategory.hideFilterTitles ? undefined : filter.name"
      :filter-counter="getSelectedCategoryFilterCounter(filter)"
      data-test-id="emh-side-filters-category-filter-template__equipment-template"
      @clear-category="onClearCategory(filter)"
    >
      <ui-checkbox-list
        :name="filter.name"
        :title="filter.title"
        :options="filter.options"
        :max-items="maxItems"
        @change="filter.handleChange"
      />
    </emh-side-filters-category-filter-template>
  </div>
</template>

<script lang="ts">
export default {
  name: 'EmhSideFiltersEquipmentCategory',
};
</script>

<script lang="ts" setup>
import { PropType, toRefs } from 'vue';
import {
  getSelectedCategoryFilterCounter,
  useMultiselectFilterCategories,
} from '../../../composables/filter-categories.composable';
import EmhSideFiltersCategoryFilterTemplate from '../sideFiltersCategoryFilterTemplate/SideFiltersCategoryFilterTemplate.vue';
import { IProductFilterGroup } from '@dh-io-emh/shared/src/models/product-filter/product-filter-base.model';
import UiCheckboxList from '@dh-io-emh/ui/src/form/checkbox/checkboxList/CheckboxList.vue';

const props = defineProps({
  filterCategory: {
    type: Object as PropType<IProductFilterGroup>,
    required: true,
  },
});

const emit = defineEmits(['change', 'clear-category']);

const { filterCategory } = toRefs(props);

const maxItems = 7;

const filters = useMultiselectFilterCategories({
  filterCategory,
  emit,
});

const onClearCategory = (filterOption) => emit('clear-category', [filterOption.code]);
</script>
